// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1M47X","footer":"ModalError_footer__3eDxx"};